__turbopack_context__.v({
  "Content": "LoyaltyJoinScreen-module-scss-module__-FbFZW__Content",
  "Description": "LoyaltyJoinScreen-module-scss-module__-FbFZW__Description",
  "FormSection": "LoyaltyJoinScreen-module-scss-module__-FbFZW__FormSection",
  "GeneralError": "LoyaltyJoinScreen-module-scss-module__-FbFZW__GeneralError",
  "Subtitle": "LoyaltyJoinScreen-module-scss-module__-FbFZW__Subtitle",
  "ThumbnailContainer": "LoyaltyJoinScreen-module-scss-module__-FbFZW__ThumbnailContainer",
  "ThumbnailScale": "LoyaltyJoinScreen-module-scss-module__-FbFZW__ThumbnailScale",
  "ThumbnailShadow": "LoyaltyJoinScreen-module-scss-module__-FbFZW__ThumbnailShadow",
  "Title": "LoyaltyJoinScreen-module-scss-module__-FbFZW__Title",
  "Wrapper": "LoyaltyJoinScreen-module-scss-module__-FbFZW__Wrapper",
});
